import styled from "styled-components/macro";
//import ErrorIcon from "../../assets/icons/Alert.svg"
//"../../assets/icons/Alert.svg";
import { ErrorMessage } from "../../styles/text";

interface Props {
  message: string;
}

export const ValidationError: React.FC<Props> = ({ message }) => {
  return (
    <Container data-testid="validation-error">
      <ErrorMessage>{message}</ErrorMessage>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-top: 0.5rem;
`;
